// @ts-nocheck
import React, { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DatePicker, InputAmount, Checkbox, notification, Modal as UiKitModal } from '@gamesb42/ui-kit';
import { Modal, Input, Form } from 'antd';
import moment from 'moment';

import { AOActionCodeEnum } from 'types/ActivationOrderTypes';
import getSaveErrorMessage from 'components/forms/ActivationOrderForm/getSaveErrorMessage';
import getActionLabel from 'components/forms/ActivationOrderForm/getActionLabel';
import { EDITABLE_AO_STATUSES } from 'components/forms/ActivationOrderForm/CardsAo/data';

import { DropdownKit, DropdownSizeEnum } from 'components/uiKit/DropdownKit';
import urls from 'constants/urls';
import endpoints from 'consts/endpoints';
import baseRequest from 'queries/baseRequest';
import { downloadFile } from 'helpers/file';
import { deleteActivationOrderDataType } from 'queries/activationOrder/deleteActivationOrder';
import useActivationOrder, { activationOrderDataType, AoTypeEnum } from 'hooks/api/useActivationOrder';
import ViewGeneralActions from 'components/common/ViewGeneralActions';
import pencilSvg from 'assets/img/newPencil.svg';
import downloadSvg from 'assets/img/newDownload.svg';
import delSvg from 'assets/img/newDelete.svg';
import archiveSvg from 'assets/img/archive.svg';
import useErrorCallback from 'hooks/useErrorCallback';
import reloadSvg from 'assets/img/reload.svg';
import reloadRedSvg from 'assets/img/reloadRed.svg';
import ChangeStatusModal from 'components/modal/ChangeStatusModal';
import { AOStatus, CompanyStatus } from 'components/common/Status';
import { changeStatusAO, changeStatusAONew, changeStatusAOForced } from 'api/ao';
import { getCompanyById } from 'api/company';
import ChangeAOStatusModal from 'components/modal/ChangeAOStatusModal';
import ChangeAOStatusForcedModal from 'components/modal/ChangeAOStatusForcedModal';
import CreateTransactionPopUp from '../../PopUps/CreateTransactionPopUp/CreateTransactionPopUp';

import s from './style.module.scss';
import FactorAccountsSelect from 'components/FactorAccountsSelect';
import useCompany, { useCompanyType } from 'hooks/api/useCompany';

type PropsT = {
  type: AoTypeEnum;
  id: activationOrderDataType['id'];
  deleteActivationOrder: (data: deleteActivationOrderDataType) => void;
  title: string;
  companyId?: string;
  setStatus?: any;
  currency: string;
  amount: string;
  status?: string;
};

const ActionsButton: FC<PropsT> = ({
  id,
  deleteActivationOrder,
  type,
  title,
  companyId,
  setStatus,
  currency,
  amount,
  status,
}) => {
  const { getAlert } = useErrorCallback();
  const history = useHistory();
  const { t } = useTranslation();
  const [isOpenChangeStatusModal, setIsOpenChangeStatusModal] = useState(false);
  const [isOpenChangeStatusForcedModal, setIsOpenChangeStatusForcedModal] = useState(false);
  const {
    getActivationOrder,
    activationOrderData,
    activationOrderActionsData,
    getActivationOrderActions,
    rejectActivationOrder,
    rejectActivationOrderIsFetching,
    deleteActivationOrderAction,
    deleteActivationOrderActionIsFetching,
    archiveActivationOrder,
    archiveActivationOrderIsFetching,
  } = useActivationOrder();
  const isActiveNow = type === AoTypeEnum.AVAILABLE_RECEIVABLES && status?.toUpperCase() === 'ACTIVE';
  const isClassic = type === AoTypeEnum.CLASSIC;
  const hasApiActions = isClassic || type === AoTypeEnum.FUTURE;

  const archiveAO = () =>
    changeStatusAONew(activationOrderId, 'ARCHIVE' as AOStatus)
      .then((result) => {
        setStatus(result || 'ARCHIVE');
        getActivationOrder({ id: activationOrderId });
        notification.success({
          message: `AO ${activationOrderData?.name ?? ''} archived successfully`.replace(/\s+/g, ' ').trim(),
          theme: 'dark',
          placement: 'bottomLeft',
        });
      })
      .catch((error) => {
        console.error('Ошибка при архивации AO:', error);
        notification.error({ message: 'Failed to archive AO', theme: 'dark', placement: 'bottomLeft' });
      });

  const confirmArchive = () =>
    UiKitModal.warning({
      title: 'Are you sure archive this AO?',
      okText: 'Archive',
      cancelText: 'Cancel',
      okButtonProps: { style: { background: '#EC3E72', border: 'none' } },
      onOk: archiveAO,
      onCancel: () => {},
    });

  const deleteAO = () =>
    deleteActivationOrder({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      id,
      successCallback: () => {
        notification.success({
          message: `AO ${activationOrderData?.name ?? ''} deleted successfully`.replace(/\s+/g, ' ').trim(),
          theme: 'dark',
          placement: 'bottomLeft',
        });
        history.push(urls.getActivationOrder());
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      errorCallback: (error) => {
        notification.error({
          message: error?.body?.description || 'Failed to delete AO',
          theme: 'dark',
          placement: 'bottomLeft',
        });
      },
    });

  const confirmDelete = () =>
    UiKitModal.warning({
      title: 'Are you sure delete this AO?',
      okText: 'Delete',
      cancelText: 'Cancel',
      okButtonProps: { style: { background: '#EC3E72', border: 'none' } },
      onOk: deleteAO,
      onCancel: () => {},
    });

  // GB42-3427 AC-21/AC-22 + MAX lifecycle doc (п.6/8): for CLASSIC/MAX the Delete/Reject/Archive
  // actions live in this three-dot menu ("отдельная вкладка"), are gated by GET .../actions and
  // executed through the new POST .../actions/{code} endpoints (not the legacy DELETE/PATCH).
  const MENU_ACTION_CONFIG = {
    [AOActionCodeEnum.REJECT]: { fn: rejectActivationOrder, image: reloadSvg, color: '#838998' },
    [AOActionCodeEnum.DELETE]: { fn: deleteActivationOrderAction, image: delSvg, color: '#EC3E72' },
    [AOActionCodeEnum.ARCHIVE]: { fn: archiveActivationOrder, image: archiveSvg, color: '#838998' },
  };

  const isMenuActionPending =
    rejectActivationOrderIsFetching || deleteActivationOrderActionIsFetching || archiveActivationOrderIsFetching;

  const runMenuAction = (action) =>
    new Promise((resolve) => {
      const config = MENU_ACTION_CONFIG[action.code];

      if (!config) {
        resolve();
        return;
      }

      config.fn({
        id,
        successCallback: (result) => {
          notification.success({
            message: t('forms.activationOrder.actionSuccess', { action: action.label }),
            theme: 'dark',
            placement: 'bottomLeft',
          });
          setStatus?.(result?.status);
          getActivationOrder({ id });
          getActivationOrderActions({ id });
          resolve();
        },
        errorCallback: (error) => {
          notification.error({ message: getSaveErrorMessage(error, t), theme: 'dark', placement: 'bottomLeft' });
          resolve();
        },
      });
    });

  const confirmMenuAction = (action) =>
    UiKitModal.warning({
      title: t('forms.activationOrder.confirmActionTitle', { action: action.label }),
      okText: action.label,
      cancelText: t('forms.activationOrder.cancel'),
      okButtonProps: { style: { background: '#EC3E72', border: 'none' } },
      onOk: () => runMenuAction(action),
      onCancel: () => {},
    });

  const apiMenuActions = hasApiActions
    ? (activationOrderActionsData?.available_actions || [])
        .filter((action) => Boolean(MENU_ACTION_CONFIG[action.code]))
        .map((action) => ({
          image: MENU_ACTION_CONFIG[action.code].image,
          title: getActionLabel(action, t),
          style: { color: MENU_ACTION_CONFIG[action.code].color },
          disabled: isMenuActionPending,
          onClick: () => confirmMenuAction(action),
        }))
    : [];

  //@ts-ignore
  const { activationOrderId } = useParams();
  const [tax, setTax] = useState();
  const [isOpenCreateTransaction, setIsOpenCreateTransaction] = useState(false);
  const {
    companiesData: { names = [] },
    companiesData,
    aoFormData,
    setAOFormData,
    listSwitch,
    setIsSwitchList,
    getCompanies,
  }: useCompanyType = useCompany();
  const [same, setSame] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [transactionData, setTransactionDate] = useState({
    recipient_company_id: companyId,
    sender_account: '',
    sender_bank_name: '',
    sender_swift: '',
    tx_date: '',
    newStatus: 'funded',
  });
  const [form] = Form.useForm();

  const clearErrors = () => {
    form.setFields([
      { name: 'tx_date', errors: [] },
      { name: 'bank_account', errors: [] },
    ]);
  };

  const createTransaction = async () => {
    try {
      await form.validateFields();

      const result = await baseRequest({
        path: `${process.env.REACT_APP_BASE_URL}/activation_order/${id}/status?recipient_company_id=${companyId}&sender_account=${transactionData.sender_account}&sender_bank_name=${transactionData.sender_bank_name}&sender_swift=${transactionData.sender_swift}&tx_date=${transactionData.tx_date}&newStatus=funded`,
        options: {
          method: 'PATCH',
        },
      });

      if (Object.hasOwn(result, 'detail')) {
        notification.error({ message: result.detail, theme: 'dark', placement: 'bottomLeft' });
      } else {
        notification.success({
          message: 'The AO status has been changed successfully',
          theme: 'dark',
          placement: 'bottomLeft',
        });
      }

      setStatus(result.status);
      getActivationOrder({ id: activationOrderId });
      setModalVisible(false);
    } catch (error) {
      console.error('Ошибка при создании транзакции:', error);
    }
  };

  useEffect(() => {
    if (companyId)
      getCompanyById(companyId)
        .then((company: any) => setTax(company?.tax_treaty))
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Не удалось загрузить компанию для AO:', error);
        });
  }, []);

  const editMenuAction = {
    disabled: !EDITABLE_AO_STATUSES.includes(status?.toUpperCase()),
    image: pencilSvg,
    title: 'forms.activationOrder.editAo',
    style: { color: '#838998' },
    onClick: () => history.push(`${urls.getActivationOrder()}/edit/${type}/${id}`),
  };

  // GB42-3427 AC-21/AC-22: for CLASSIC/MAX and FUTURE the lifecycle menu items
  // (Delete/Reject/Archive) come from GET .../actions and go through the new
  // POST .../actions/* endpoints. Sign/Fund are rendered separately as buttons by AOActionsBar.
  // Other AO types keep the legacy Delete/Archive menu items.
  const legacyMenuActions = isActiveNow
    ? [
        {
          image: archiveSvg,
          title: 'forms.activationOrder.archiveAo',
          style: { color: '#838998' },
          onClick: confirmArchive,
        },
      ]
    : [
        {
          image: delSvg,
          title: 'forms.activationOrder.deleteAo',
          style: { color: '#EC3E72' },
          onClick: confirmDelete,
        },
      ];

  const menuActions = [
    editMenuAction,
    // {
    //   image: reloadSvg,
    //   title: 'company.changeStatus',
    //   style: { color: '#838998' },
    //   onClick: () => setIsOpenChangeStatusModal(true),
    // },
    // {
    //   image: reloadRedSvg,
    //   title: 'company.changeStatusForced',
    //   style: { color: '#EC3E72' },
    //   onClick: () => setIsOpenChangeStatusForcedModal(true),
    // },
    ...(hasApiActions ? apiMenuActions : legacyMenuActions),
  ];

  return (
    <div style={{ position: 'absolute', top: -83, right: 0 }}>
      <ViewGeneralActions buttonList={menuActions} />
      {isOpenChangeStatusModal && (
        <ChangeAOStatusModal
          tax={tax}
          isCompany={false}
          currentStatus={activationOrderData.status}
          isOpen={isOpenChangeStatusModal}
          onClose={() => setIsOpenChangeStatusModal(false)}
          handleConfirmClick={(status) => {
            setIsOpenChangeStatusModal(false);

            if (activationOrderData.status === 'ACTIVE') {
              clearErrors();
              setModalVisible(true);
              return;
            }

            // @ts-ignore
            changeStatusAONew(activationOrderId, status as AOStatus)
              .then((result) => {
                setStatus(result);
                if (Object.hasOwn(result, 'detail')) {
                  notification.error({ message: result.detail, theme: 'dark', placement: 'bottomLeft' });
                } else {
                  notification.success({
                    message: 'The AO status has been changed successfully',
                    theme: 'dark',
                    placement: 'bottomLeft',
                  });
                }
              })
              .catch(console.error);
          }}
        />
      )}
      {isOpenChangeStatusForcedModal && (
        <ChangeAOStatusForcedModal
          tax={tax}
          isCompany={false}
          currentStatus={activationOrderData.status}
          isOpen={isOpenChangeStatusForcedModal}
          onClose={() => setIsOpenChangeStatusForcedModal(false)}
          handleConfirmClick={(status) => {
            setIsOpenChangeStatusForcedModal(false);

            // @ts-ignore
            changeStatusAOForced(activationOrderId, status as AOStatus)
              .then((result) => {
                setStatus(result);
                if (Object.hasOwn(result, 'detail')) {
                  notification.error({ message: result.detail, theme: 'dark', placement: 'bottomLeft' });
                } else {
                  notification.success({
                    message: 'The AO status has been changed successfully (forced)',
                    theme: 'dark',
                    placement: 'bottomLeft',
                  });
                }
              })
              .catch(console.error);
          }}
        />
      )}
      <Modal
        className={s.createT}
        title="Create transaction"
        visible={modalVisible}
        okText="Create transaction"
        onOk={() => createTransaction()}
        onCancel={() => setModalVisible(false)}
        centered
      >
        <Form form={form} className={s.form}>
          <div className={s.row}>
            <div className={s.classFullWidth}>
              <Form.Item name="tx_date" rules={[{ required: true, message: 'Please input date' }]}>
                <DatePicker
                  onChange={(e) => {
                    if (e) {
                      setTransactionDate({ ...transactionData, tx_date: e.format('YYYY-MM-DD') });
                    } else {
                      setTransactionDate({ ...transactionData, tx_date: '' });
                    }
                  }}
                  label="Date"
                  size="large"
                  format="DD.MM.YYYY"
                  aria-required
                />
              </Form.Item>
            </div>

            <div className={s.classFullWidth}>
              <InputAmount value={amount} label="Amount" currency={currency} size="large" disabled />
            </div>
          </div>
          <Form.Item name="bank_account" rules={[{ required: true, message: 'Please input factor bank account' }]}>
            <FactorAccountsSelect
              needSetDefaultValue
              currency="USD"
              onChange={(account, { source: { bank_name, swift } }) => {
                setTransactionDate({
                  ...transactionData,
                  sender_account: account,
                  sender_bank_name: bank_name,
                  sender_swift: swift,
                });
              }}
              required
              getPopupContainer={(triggerNode) => triggerNode.parentElement}
            />
          </Form.Item>
          <Checkbox
            style={{ marginBottom: '32px' }}
            checked={same}
            onChange={(e) => {
              names.length === 0 && getCompanies({ showDeleted: false });
              setSame(e.target.checked);
              if (e.target.checked) {
                setTransactionDate({ ...transactionData, recipient_company_id: aoFormData.company_id });
              } else {
                setTransactionDate({ ...transactionData, recipient_company_id: '' });
              }
            }}
          >
            Recipient is the same as Client
          </Checkbox>

          {!same && (
            <DropdownKit
              label="Recipient"
              options={names}
              keyObj="name"
              value=""
              value={names.find((val) => val.id === aoFormData.recipient) || ''}
              changeSelectItem={(_, data) => {
                setTransactionDate({ ...transactionData, recipient_company_id: data.id });
              }}
              positionType={DropdownSizeEnum.SIZE_60}
            />
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default ActionsButton;
